// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 36 36\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M30 2v32H6V2h24zM20 4H8v28h20V12a8 8 0 01-8-8zm5 20v2H11v-2h14zm0-5v2H11v-2h14zm-7-5v2h-7v-2h7zM28 4h-6a6 6 0 006 6V4z\" fill=\"currentColor\" fill-rule=\"evenodd\"/></svg>";
// Exports
module.exports = code;